
        var result = require("!!./../../../node_modules/css-loader/index.js!./stil.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/komponente/izvestaj/stil.css
// module id = 54
// module chunks = 0